import apiHelper from '@api/helper'
import constants from '@/services/constants'
import store from '@store'
const state = {
    listField: [],
    listFieldCompany: [],
    listJustification: [],
    listCompany: [],
    listDepartment: [],
    listLocation: [],
    listMaterialType: [],
    listWasteContractor: [],
    listBuyer: [],
    listReturnType: [],
    listModifyType: [],
    listMaterialGroup: []
}

const getters = {
  getField () {
    return state.listField
  },
  getFieldCompany() {
    return state.listFieldCompany
  },
  getJustification () {
    return state.listJustification
  },
  getCompany() {
    return state.listCompany
  },
  getDepartment () {
    return state.listDepartment
  },
  getLocation () {
    return state.listLocation
  },
  getMaterialType () {
    return state.listMaterialType
  },
  getWasteContractor() {
    return state.listWasteContractor
  },
  getBuyer() {
    return state.listBuyer
  },
  getReturnType() {
    return state.listReturnType
  },
  getModifyType() {
    return state.listModifyType
  },
  getMaterialGroup() {
    return state.listMaterialGroup
  }
}

const actions = {
  'INIT_MASTER': async ({commit, dispatch}, payload) => {
    let result = {}
    let promiseField =  apiHelper.master.getField()
    let promiseFieldCompany =  apiHelper.master.getFieldCompany()
    let promiseJustification =  apiHelper.justification.getJustification()
    let promiseCompany = apiHelper.master.getCompany()
    let promiseDepartment = apiHelper.master.getDepartment()
    let promiseLocation =  apiHelper.master.getLocation()
    let promiseMaterialType = apiHelper.master.getMaterialType()
    let promiseWasteContractor = apiHelper.master.getWasteContractor()
    let promiseBuyer = apiHelper.buyer.getBuyer()
    let promiseReturnType = apiHelper.master.getReturnType()
    let promiseModifyType = apiHelper.master.getModifyType()
    let promiseMaterialGroup = apiHelper.master.getMaterialGroup()

    mapRequestToState(promiseField, commit, 'mutationSetField')
    mapRequestToState(promiseFieldCompany, commit, 'mutationSetFieldCompany')
    mapRequestToState(promiseJustification, commit, 'mutationSetJustification')
    mapRequestToState(promiseCompany, commit, 'mutationSetCompany')
    mapRequestToState(promiseDepartment, commit, 'mutationSetDepartment')
    mapRequestToState(promiseLocation, commit, 'mutationSetLocation')
    mapRequestToState(promiseMaterialType, commit, 'mutationSetMaterialType')
    mapRequestToState(promiseWasteContractor, commit, 'mutationSetWasteContractor')
    mapRequestToState(promiseBuyer, commit, 'mutationSetBuyer')
    mapRequestToState(promiseReturnType, commit, 'mutationSetReturnType')
    mapRequestToState(promiseModifyType, commit, 'mutationSetModifyType')
    mapRequestToState(promiseMaterialGroup, commit, 'mutationSetMaterialGroup')
  }
}

const mutations  = {
    mutationSetField (state, payload) {
      state.listField = payload
    },
    mutationSetFieldCompany (state, payload) {
      state.listFieldCompany = payload
    },
    mutationSetJustification (state, payload) {
      state.listJustification = payload
    },
    mutationSetCompany (state, payload) {
      state.listCompany = payload
    },
    mutationSetDepartment (state, payload) {
      state.listDepartment = payload
    },
    mutationSetLocation (state, payload) {
      state.listLocation = payload
    },
    mutationSetMaterialType(state, payload) {
      state.listMaterialType = payload
    },
    mutationSetWasteContractor(state, payload) {
      state.listWasteContractor = payload
    },
    mutationSetBuyer(state, payload) {
      state.listBuyer = payload
    },
    mutationSetReturnType(state, payload) {
      state.listReturnType = payload
    },
    mutationSetModifyType(state, payload) {
      state.listModifyType = payload
    },
    mutationSetMaterialGroup(state, payload) {
      state.listMaterialGroup = payload
    }
}

var mapRequestToState = async (promise,commit, mutation) => {
    promise.then(res => {
      let data = res.data
      if(data.responseStatus.responseCode === 'SUCCESS') {
        commit(mutation, data.responseData)
      }
    })
    .catch(err => {
      console.error('get data fail', promise)
    })
  }
export default {
  actions, 
  getters, 
  state, 
  mutations
}
